import { Injectable } from '@angular/core';
import { Cable } from './cable';
export class ActionCableService {
private cables: {[s: string]: Cable} = {};
/**
 * Open a new ActionCable connection to the url. Any number of connections can be created.
 * @param {?} url
 * @param {?=} params
 * @return {?}
 */
cable(url: string, params?: any): Cable {
    if (!this.cables.hasOwnProperty(url)) {
      this.cables[url] = new Cable(url, params);
    }

    return this.cables[url];
  }
/**
 * Close an open connection for the url.
 * @param {?} url
 * @return {?}
 */
disconnect(url: string): void {
    if (this.cables.hasOwnProperty(url)) {
      this.cables[url].disconnect();
      delete this.cables[url];
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ActionCableService_tsickle_Closure_declarations() {
/** @type {?} */
ActionCableService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ActionCableService.ctorParameters;
/** @type {?} */
ActionCableService.prototype.cables;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ts/src/action-cable.service.ts